import { List, Typography } from "@mui/material"

export const FillToolTipContent = () => {
    return (
        <Typography ml={1} fontWeight={"bold"}>
                Explaination: <span style={{ fontWeight: "normal" }}>
                  Signals are collected at different frequencies and often do not line
                  up with other channels. You may want fill the data on some or all your
                  channels.
                </span>
                <ul style={{ margin: "unset" }}>
                  <List>
                    <Typography fontWeight={'normal'}>
                      Select the signals you want to fill.
                    </Typography>
                  </List>
                  <List>
                    <Typography fontWeight={'normal'}>
                      Select the fill Method.
                    </Typography>
                  </List>
                  <List>
                    <Typography fontWeight={'normal'}>
                      Click “SUBMIT” Button.
                    </Typography>
                  </List>
                </ul>
                <Typography fontWeight={'normal'}>
                  Filling requires the data to be broken up into trips.
                </Typography>
              </Typography>
    )
}